import type {
  CatalystQuestionAndAnswer,
  LiteratureQuestionAndAnswer,
  ModelQuestionAndAnswer,
  ModifiedConfigModelQuestionAndAnswer,
  SwitchToModelExpertPrompt,
} from "./types";
import {
  isLiteratureQuestionAndAnswer,
  isModelQuestionAndAnswer,
  isModifiedConfigModelQuestionAndAnswer,
  isSwitchToModelExpertPrompt,
} from "./types";

export const TEST_IDS = {
  applyModelExpertChanges: "catalyst.modified-config.apply-button",
  drawerContent: "catalyst.drawer-content",
  modelExpertWelcomePrompt: "model-expert-welcome-prompt",
  modeSelector: "catalyst.mode-selector",
  openButton: "catalyst.open-button",
  questionAndAnswer: "catalyst.question-and-answer",
  questionTextField: "catalyst.question-text-field",
  rejectModelExpertChanges: "catalyst.modified-config.cancel-button",
  switchToModelExpertPromptAcceptButton:
    "catalyst.switch-to-model-expert.accept-button",
  switchToModelExpertPromptDeclineButton:
    "catalyst.switch-to-model-expert.decline-button",
  documentManagerButton: "catalyst.document-manager.redirect-to-data-manager",
};

export const isUnresolvedModifiedConfigModelQuestionAndAnswer = (
  questionAndAnswer: CatalystQuestionAndAnswer,
): questionAndAnswer is ModifiedConfigModelQuestionAndAnswer => {
  return Boolean(
    isModifiedConfigModelQuestionAndAnswer(questionAndAnswer) &&
    questionAndAnswer.answer &&
    questionAndAnswer.state === "idle",
  );
};

export const isWaitingForAnswer = (
  questionAndAnswer: CatalystQuestionAndAnswer,
): questionAndAnswer is
  | LiteratureQuestionAndAnswer
  | ModelQuestionAndAnswer => {
  return (
    (isModelQuestionAndAnswer(questionAndAnswer) ||
      isLiteratureQuestionAndAnswer(questionAndAnswer)) &&
    !questionAndAnswer.answer &&
    !questionAndAnswer.error
  );
};

export const isAnsweredOrErrored = (
  questionAndAnswer: CatalystQuestionAndAnswer,
) => {
  return !isWaitingForAnswer(questionAndAnswer);
};

export const isResolved = (questionAndAnswer: CatalystQuestionAndAnswer) => {
  const hasState = isModifiedConfigModelQuestionAndAnswer(questionAndAnswer);
  return hasState
    ? questionAndAnswer.state === "applied" ||
        questionAndAnswer.state === "rejected"
    : isAnsweredOrErrored(questionAndAnswer);
};

export const isIdleSwitchToModelExpertPrompt = (
  questionAndAnswer: CatalystQuestionAndAnswer,
): questionAndAnswer is SwitchToModelExpertPrompt => {
  return (
    isSwitchToModelExpertPrompt(questionAndAnswer) &&
    questionAndAnswer.state === "idle"
  );
};
